import { useAtomValue } from 'jotai';
import { Outlet, useParams } from 'react-router-dom';

import { AuthPageLayout } from '@ekhodealer/ekho-common/auth-client';
import { SteppedProgressBar } from '@ekhodealer/ekho-common/rev';

import {
	EXISTING_DEALER_STEPS,
	hasPreSelectedProductAtom,
	NEW_DEALER_STEPS,
	onboardingStepAtom,
	PRE_SELECTED_STEPS,
} from '../atoms/onboardingAtoms';

import './OnboardingSteps.scss';

export default function OnboardingLayout() {
	const currentStep = useAtomValue(onboardingStepAtom);
	const hasPreSelected = useAtomValue(hasPreSelectedProductAtom);
	const { svpId } = useParams();
	const isExistingDealer = !!svpId;

	const steps = isExistingDealer
		? hasPreSelected
			? PRE_SELECTED_STEPS
			: EXISTING_DEALER_STEPS
		: NEW_DEALER_STEPS;

	return (
		<AuthPageLayout contentClassName='onboarding-layout' showPoweredBy={false}>
			<SteppedProgressBar
				steps={[...steps]}
				currentStepIndex={currentStep}
				showLabels={false}
			/>
			<Outlet />
		</AuthPageLayout>
	);
}
